import { render, staticRenderFns } from "./PosWorkspace.vue?vue&type=template&id=6566a0d2"
import script from "./PosWorkspace.vue?vue&type=script&lang=js"
export * from "./PosWorkspace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports